<template lang='pug'>
    div(class="pt-2" style="float:right;")
        div( v-if="researchExists && getNumberOfMonths <= 3")
            v-icon( @click="gotoResearch(ticker)" style="margin-right:18px;" class="research-change-size") $researchNewTest

        div( v-else-if="!researchExists" style="position: relative;")
            v-tooltip( bottom)
                template( v-slot:activator="{ on, attrs }")
                    div( v-bind="attrs" v-on="on" style="padding-bottom:17px;")
                        div( style="position: absolute;left: -38px;")
                            v-icon( @click="gotoResearch(ticker)" class="research-change-size") $researchNoNewTest

                span Write Research

        div( v-else)
            div( @click="gotoResearch(ticker)" style="position:relative;")
                v-tooltip( bottom)
                    template( v-slot:activator="{ on, attrs }")
                        div( v-bind="attrs" v-on="on" style="padding-bottom:18px;")
                            div( style="position:absolute; z-index:1; left:-40px;")
                                v-icon $researchNewTest
                            div( style="position:absolute; z-index:2; top:10px; left:-31px;")
                                v-icon $circle

                    span Not updated in {{ Math.floor(getNumberOfMonths) }} months
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Vue from 'vue';

export default Vue.extend({
    created() {
        if (this.params) {
            this.item = this.params.data;
        }
    },
    mounted() {
        this.ticker = this.getValue();
    },
    data: function() {
        return {
            ticker: '',
            item: null
        };
    },
    computed: {
        ...mapGetters([
            'getResearchs'
        ]),
        stock_id() {
            return this.params.data.stock_id;
        },
        researchExists() {
            return this.getResearchs.filter((r) => r.stock_id === this.stock_id).length > 0;
        },
        research() {
            return this.researchExists ? this.getResearchs.find((r) => r.stock_id === this.stock_id) : -1;
        },
        getNumberOfMonths() {
            if(this.researchExists) {
                const given = moment(this.research.last_update_date, 'YYYY-MM-DD');
                const current = moment(new Date().toISOString().slice(0, 10), 'YYYY-MM-DD');

                const months = -moment.duration(given.diff(current)).asMonths();

                return months;
            }

            return -1;
        }
    },
    methods: {
        getValue() {
            return this.params.value;
        },
        gotoResearch(ticker) {
            this.params.action(ticker);
        }
    }
});
</script>

<style scoped>
>>> .research-change-size {
    transform: scale(1.2, 1.2);
}


>>> .set-research-new-container {
    transform: scale(1, 1.1);
}

>>> .set-research-background-new-color {
    fill: #25B19A;
}

>>> .set-research-new-color {
    fill: #ffffff;
}


>>> .set-research-no-new-container {
    transform: scale(1, 1.1);
}

>>> .set-research-background-no-new-color {
    fill: #d1d0d0;
}

>>> .set-research-no-new-color {
    fill: #ffffff;
}


>>> .set-circle-container {
    width: 20px;
    height: 20px;
}

>>> .set-circle-color {
    fill: #E72929;
}
</style>
